/* LADA — product-share.js (PDP-05)
   Sdílení modelu: nativní systémový dialog (Web Share API) přímo z klepnutí, s názvem modelu a čistou veřejnou URL
   (ověřená doména obchodu, jazyk/trh podle stránky, platná zvolená varianta; bez preview, tracking a session parametrů).
   Bez podpory nebo po chybě: malý panel „Kopírovat odkaz“ – potvrzení až po úspěšném zápisu do schránky, při zamítnutí
   označená URL k ručnímu kopírování. Zrušení systémového dialogu není chyba. Nic se neodesílá automaticky. */
(function () {
  'use strict';
  const btn = document.querySelector('[data-share]');
  if (!btn) return;
  const S = (window.ladaTheme && window.ladaTheme.strings) || {};
  const panel = document.querySelector('[data-share-panel]');
  const input = panel ? panel.querySelector('[data-share-input]') : null;
  const copyBtn = panel ? panel.querySelector('[data-share-copy]') : null;
  const statusEl = panel ? panel.querySelector('[data-share-status]') : null;
  function cleanUrl() {
    let u;
    try { u = new URL(btn.dataset.shareUrl || '', window.location.origin); } catch (e) { u = new URL(window.location.pathname, window.location.origin); }
    u.search = ''; u.hash = '';
    const vid = document.querySelector('[data-product] [data-variant-id]');
    if (vid && !vid.disabled && vid.value) u.searchParams.set('variant', vid.value);
    return u.toString();
  }
  function openPanel() { if (!panel) return; panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); input.value = cleanUrl(); if (statusEl) statusEl.textContent = ''; input.focus(); input.select(); }
  function closePanel(refocus) { if (!panel) return; panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); if (refocus) btn.focus(); }
  btn.addEventListener('click', () => {
    const data = { title: btn.dataset.shareTitle || document.title, url: cleanUrl() };
    const canNative = typeof navigator.share === 'function' && (typeof navigator.canShare !== 'function' || navigator.canShare(data));
    if (canNative) {
      navigator.share(data).catch(err => { if (err && err.name === 'AbortError') return; openPanel(); });
      return;
    }
    if (!panel) return;
    if (panel.hidden) openPanel(); else closePanel(true);
  });
  if (copyBtn) copyBtn.addEventListener('click', () => {
    const url = cleanUrl(); input.value = url;
    const fail = () => { input.focus(); input.select(); if (statusEl) statusEl.textContent = S.shareCopyFailed || ''; };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(() => { if (statusEl) statusEl.textContent = S.shareCopied || ''; }).catch(fail);
    } else fail();
  });
  if (panel) panel.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); closePanel(true); } });
  if (input) input.addEventListener('focus', () => input.select());
})();
